import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import DriverTabData from './DriverTab';

interface DriverJob {
    id: number;
    jobId: number;
    truckId: number;
    siteAddress: string;
    siteAddressGoogle: string;
    siteAddressLatitude: number;
    siteAddressLongitude: number;
    siteContact: string;
    customer: string;
    gateCode: string;
    estimatedTime: string;
    jobNotes: string;
    items: DriverJobItems[];
    hasArrived: boolean;
    isComplete: boolean;
    truckAccess: boolean;
    parking: boolean;
    siteClean: boolean;
    powerlinesWithinRange: boolean;
    siteHasIssues: boolean;
    showSiteIssues: boolean;
    isAssistJob: boolean;
    isManualJob: boolean;
    isDriverJob: boolean;   //means the driver added so can move
    vehicleItemOrder: number;
    plans: PlanFile[];
}

interface DriverJobItems {
    id: number;
    kwikstageId: number;
    unitNumberDisplay: string;
    type: string;
    typeId: number;
    item: string;
    itemId: number;
    quantity: number;
    itemQuantityType: string;
    estimatedTime: string;
    estimatedTimeMins: number;
    isComplete: boolean;
    percentComplete: number;    //used for Kwikstage
    vehicleItemOrder: number;   //used when adding manual job after a linked job
    itemParts: ItemPart[];
}

interface ItemPart {
    itemPartId: number;
    part: string;
    isComplete: boolean;
}

interface PlanFile {
    id: number;
    fileName: string;
}

const DriverJobsTomorrowData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [scheduleDateFormatted, setScheduleDateFormatted] = React.useState("");
    const [driverJobs, setDriverJobs] = React.useState<DriverJob[]>([]);
    const [truckId, setTruckId] = React.useState(-1);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Job/GetDriverJobsTomorrow?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setScheduleDateFormatted(res.data.scheduleDateFormatted);
            setDriverJobs(res.data.driverJobs);
            setTruckId(res.data.truckId);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        }); 
    }

    const showSiteIssues = (e: any, jobIndex: number) => {
        e.preventDefault();

        var jobs = [...driverJobs]
        var job = jobs[jobIndex];

        job.showSiteIssues = !job.showSiteIssues;

        setDriverJobs(jobs);
    }

    const downloadPlan = (e: any, id: number) => {
        e.preventDefault();
        getPlanFile(id);
    }

    const getPlanFile = async (id: number) => {
        const token = await authService.getAccessToken();

        axios('api/Job/GetJobPlans?Id=' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            var fileheader = res.headers["content-disposition"];
            var filename = "plans.pdf";
            if (fileheader) {
                filename = fileheader.split('filename=')[1].split(';')[0];
                filename = filename.replaceAll('"', '');
            }
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const powerlinesText = "Powerlines < 4.6 m";
    var driverTabsMobile = <DriverTabData tab="driverjobs" truckId={truckId} />

    const renderDetails = (
        <div>
            <div className={driverJobs.length === 0 ? "hidden" : ""}>
                {driverJobs.map((job, index) =>
                    <div key={index}>
                        <div className="makeitflexspacebetween makeitcentervertical">
                            <div className="driverjobs-min20">
                                {index + 1}
                            </div>
                            <div className="makeitbold marginRight10 driverjobs-address">
                                {job.siteAddress}
                                <a className="marginLeft10" href={job.siteAddressGoogle} target="_blank" >
                                    <span className="fas fa-map-marker-alt edit--icon"></span>
                                </a>
                            </div>
                        </div>
                        <div className="makeitflexspacebetween makeitcentervertical">
                            <div>
                                {job.customer}
                            </div>
                            <div className="makeitbold">
                                <span className={job.gateCode ? "" : "hidden"}>g/c: </span>{job.gateCode}
                            </div>
                        </div>
                        <div className="makeitflexspacebetween makeitcentervertical">
                            <div>
                                {job.siteContact}
                            </div>
                            <div className={job.siteHasIssues ? "" : "hidden"}>
                                <i className="fas fa-ban edit--icon--large makeitred" onClick={(e) => showSiteIssues(e, index)}></i>
                            </div>
                        </div>
                        <div className={job.showSiteIssues ? "makeitred" : "hidden"}>
                            <div className={job.truckAccess ? "hidden" : ""}>No Truck Access</div>
                            <div className={job.parking ? "hidden" : ""}>No Parking Available</div>
                            <div className={job.siteClean ? "hidden" : ""}>Site is not clean</div>
                            <div className={job.powerlinesWithinRange ? "" : "hidden"}> {powerlinesText}</div>
                        </div>
                        <div>
                            {job.items.map((item, index) =>
                                <div key={index} className="makeitflexspacebetween">
                                    <div>
                                        {item.unitNumberDisplay === "" ? "" : item.unitNumberDisplay + " - "}
                                        {item.type}
                                    </div>
                                    <div>
                                        {item.item}
                                    </div>
                                    <div>
                                        {item.itemQuantityType}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="makeititalic driverjobs--notes">
                            {job.jobNotes}
                        </div>
                        <div className="alignitemscentre">
                            <div className={job.plans.length > 0 ? "" : "hidden"}>
                                {job.plans.map((plan, index) =>
                                    <div key={plan.id}>
                                        <a href="#" onClick={(e) => downloadPlan(e, plan.id)}>{plan.fileName}</a>
                                    </div>
                                )}

                            </div>
                        </div>
                        <hr className="hr--no-margin"></hr>
                    </div>
                )}
            </div>
            <div className={driverJobs.length === 0 ? "" : "hidden"}>
                There are no jobs allocated to you for this date yet.
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <div className="mobileFont marginTop70 marginBottom70">
                <div className="makeitflexspacebetween marginBottom10">
                    <h1>Jobs for {scheduleDateFormatted}</h1>
                </div>
            
                <hr></hr>
                {contents}
            </div>
            <div>
                {driverTabsMobile}
            </div>
        </div>
    );
}

export default DriverJobsTomorrowData;
